module.exports = __webpack_public_path__ + "static/media/ic_add.05d9ad4e.svg";